export default "/images/facebook.svg?54b6ed1796ae51e7991a86b99ceb8334";